import { Box, Card, CardContent, Grid } from "@mui/material";
import { Clear, Description, Edit, Grading, Search } from "@mui/icons-material";
import { GridActionsCellItem, GridRowId, GridRowModel, GridSortDirection, GridSortModel } from "@mui/x-data-grid";
import { useEffect, useMemo, useState } from "react";

import AutoComplete from "../../../components/hookForms/autoComplete";
import { Button } from "@mui/material";
import { Container } from "../../../theme/globalStyles";
import DataTable from "../../../components/dataTable";
import DialogEdit from "./modal/dialogEdit";
import InputDocumento from "../../../components/hookForms/inputDocumento";
import TextInput from "../../../components/hookForms/textField";
import Tooltip from "@mui/material/Tooltip";
import messages from "../../../utils/messages";
import serviceCliente from "../../../services/serviceCliente";
import { toast } from "react-toastify";
/* eslint-disable react-hooks/exhaustive-deps */
import { useAuth } from "../../../context/global";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";

const Cliente = (props: any) => {
    const { setTitlePage } = useAuth();

    useEffect(() => {
        setTitlePage("Cadastro - Cliente");
    }, [setTitlePage]);

    const [data, setData] = useState<any[]>([]);
    const [pageSize, setPageSize] = useState(100);
    const [page, setPage] = useState(0);
    const [filters, setFilters] = useState(null);
    const [rowCount, setRowCount] = useState(0);
    const [isLoading, setLoading] = useState(false);
    const history = useHistory();

    const [sortModel, setSortModel] = useState<GridSortModel>([
        {
            field: "",
            sort: "" as GridSortDirection,
        },
    ]);

    const [editState, setEditState] = useState({
        open: false,
        id: "",
        tipoFaturaCliente: "",
        nomeCliente: "",
        codigoExternoCliente: "",
        numeroDocumentoClienteFormatado: "",
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        defaultValues: {
            codigoExternoCliente: "",
            nomeCliente: "",
            numeroDocumentoCliente: "",
            tipoFaturaCliente: "",
        },
    });

    const actionColumns = useMemo(
        () => [
            {
                headerName: "Operações",
                field: "operations",
                type: "actions",
                width: 220,
                hide: false,
                getActions: (params: { id: GridRowId; row: GridRowModel }) => [
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Editar">
                                <Edit />
                            </Tooltip>
                        }
                        label="Editar"
                        onClick={() =>
                            setEditState({
                                open: true,
                                id: params.id.toString(),
                                tipoFaturaCliente: params.row.tipoFaturaCliente,
                                nomeCliente: params.row.nomeCliente,
                                codigoExternoCliente: params.row.codigoExternoCliente,
                                numeroDocumentoClienteFormatado: params.row.numeroDocumentoClienteFormatado,
                            })
                        }
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Instalações do cliente">
                                <Grading />
                            </Tooltip>
                        }
                        label="Instalações do cliente"
                        onClick={() => 
                            onClickInstalacoesCliente(
                                params.row.clienteID, 
                                params.row.nomeCliente,
                                params.row.numeroDocumentoCliente)
                            }
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Faturas de instalação">
                                <Description />
                            </Tooltip>
                        }
                        label="Faturas de instalação"
                        onClick={() => onClickFaturasInstalacao(params.row.clienteID)}
                    />,
                ],
            },
        ],
        [filters]
    );

    const columns = useMemo(
        () => [
            {
                headerName: "ID",
                field: "clienteID",
                type: "number",
                headerAlign: "left",
                identity: true,
                width: 100,
            },
            {
                headerName: "Nome",
                field: "nomeCliente",
                type: "string",
                width: 500,
            },
            {
                headerName: "Documento",
                field: "numeroDocumentoClienteFormatado",
                type: "string",
                width: 200,
            },
            {
                headerName: "Código externo",
                field: "codigoExternoCliente",
                type: "number",
                headerAlign: "left",
                width: 180,
            },
            {
                headerName: "Faturar por",
                field: "tipoFaturaCliente",
                type: "string",
                width: 180,
            },
            ...actionColumns,
        ],
        [actionColumns]
    );

    const tipoFaturaClienteOptions = [
        { label: "Todos", value: "Todos" },
        { label: "Cliente", value: "Cliente" },
        { label: "Instalação", value: "Instalação" },
    ];

    const getAllWithFilters = async (filters: any) => {
        setData([]);
        setLoading(true);

        serviceCliente
            .getWithFilter({
                ...filters,
                take: pageSize,
                currentPage: page + 1,
                sortExpression: sortModel[0]?.field ?? "",
                sortDirection: sortModel[0]?.sort ?? "",
            })
            .then((result) => {
                setData(result?.data.content);
                setRowCount(result?.data.numberOfElements);
            })
            .catch((err) => {
                toast.error(messages.getWithFilterError, err);
                setData([]);
                setRowCount(0);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(
        () => {
            getAllWithFilters(filters);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [page, pageSize, sortModel]
    );

    const onClickInstalacoesCliente = (clienteID: any, nomeCliente: any, numeroDocumentoCliente: any) => {
        history.push(
            "/cadastros/clienteinstalacao",
            { 
                clienteID: clienteID, 
                nomeCliente: nomeCliente,
                numeroDocumentoCliente: numeroDocumentoCliente,
                filterOld: filters,
                rotaAnterior: "/cadastros/cliente"
            },
        );
    };

    const onClickFaturasInstalacao = (clienteID: any) => {
        history.push(
            "/faturamento/faturainstalacao",
            { 
                clienteID: clienteID, 
                statusFaturaInstalacao: "", 
                filterOld: filters,
                rotaAnterior: "/cadastros/cliente"
            },
        );
    };
  
    const onSubmit = (values: any) => {
        const newFilters = {
            ...values,
            tipoFaturaCliente: values.tipoFaturaCliente === "Todos" ? "" : values.tipoFaturaCliente,
        };

        setFilters(newFilters);
        getAllWithFilters(newFilters);
    };

    const onClear = () => {
        reset({
            codigoExternoCliente: "",
            nomeCliente: "",
            numeroDocumentoCliente: "",
            tipoFaturaCliente: "",
        });
        setFilters(null);
        getAllWithFilters(null);
    };

    const onSuccessAction = () => {
        getAllWithFilters(filters);
    };

    useEffect(() => {
        if (props && props.location && props.location.state) {
            getAllWithFilters(props.location.state);
            setFilters(props.location.state);
            reset({ ...props.location.state });
        }
    }, [props]);
    
    return (
        <Container>
            <Card>
                <CardContent>
                    <Box sx={{ mb: 2 }}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Grid container spacing={2}>
                                <Grid item md={12}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={2}>
                                            <TextInput
                                                name="codigoExternoCliente"
                                                label="Código externo"
                                                control={control}
                                                error={errors}
                                                maxLength={20}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={2}>
                                            <TextInput
                                                name="nomeCliente"
                                                label="Nome cliente"
                                                control={control}
                                                error={errors}
                                                maxLength={200}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={2}>
                                            <InputDocumento
                                                name="numeroDocumentoCliente"
                                                label="Documento"
                                                control={control}
                                                error={errors}
                                                maxLength={20}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={2}>
                                            <AutoComplete
                                                name="tipoFaturaCliente"
                                                label="Faturar por"
                                                options={tipoFaturaClienteOptions}
                                                control={control}
                                                error={errors}
                                            />
                                        </Grid>

                                        <Grid item md={2}>
                                            <Button
                                                disableElevation
                                                variant="contained"
                                                color="warning"
                                                fullWidth
                                                style={{ margin: "16px 0px 8px 0px" }}
                                                startIcon={<Search />}
                                                type="submit"
                                                disabled={isLoading}
                                            >
                                                Pesquisar
                                            </Button>
                                        </Grid>

                                        <Grid item md={2}>
                                            <Button
                                                disableElevation
                                                variant="outlined"
                                                color="warning"
                                                fullWidth
                                                style={{ margin: "16px 0px 8px 0px" }}
                                                startIcon={<Clear />}
                                                onClick={() => onClear()}
                                            >
                                                Limpar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </form>
                    </Box>

                    <Box sx={{ height: 450 }}>
                        <DataTable
                            columns={columns}
                            rows={data}
                            rowId={(row: GridRowModel) => row.clienteID}
                            rowCount={rowCount}
                            isLoading={isLoading}
                            onPageChange={(currentPage: number) => setPage(currentPage)}
                            onPageSizeChange={(currentPageSize: number) => setPageSize(currentPageSize)}
                            pageSize={pageSize}
                            onSortModelChange={(model: GridSortModel) => setSortModel(model)}
                        />
                    </Box>

                    <DialogEdit
                        open={editState.open}
                        onSuccess={() => onSuccessAction()}
                        data={{
                            open: editState.open,
                            id: editState.id,
                            tipoFaturaCliente: editState.tipoFaturaCliente,
                            nomeCliente: editState.nomeCliente,
                            codigoExternoCliente: editState.codigoExternoCliente,
                            numeroDocumentoClienteFormatado: editState.numeroDocumentoClienteFormatado,
                        }}
                        onClose={() => {
                            setEditState({
                                open: false,
                                id: "",
                                tipoFaturaCliente: "",
                                nomeCliente: "",
                                codigoExternoCliente: "",
                                numeroDocumentoClienteFormatado: "",
                            });
                        }}
                    />
                </CardContent>
            </Card>
        </Container>
    );
};

export default Cliente;
